import React, { useState, useCallback, useRef, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, TextField, Grid, Box, Typography } from "@mui/material";

const ImageUploader = ({
  previewImgPath,
  expectedWidth,
  expectedHeight,
  post,
  ImageType,
  setPathFunc
}) => {
  const [logoPath, setLogoPath] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        width: "100%",
        alignItems: "flex-start"
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: 209,
          flexGrow: 1
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={previewImgPath}
            alt="Logo preview"
            style={{
              // width: 40,
              // height: 40,
              maxWidth: 200,
              maxHeight: 80,
              objectFit: "cover",
              borderRadius: 4,
              border: "1px solid #e0e0e0"
            }}
          />
        </Box>
        {expectedWidth && expectedHeight ? (
          <div
            style={{ color: "grey", fontStyle: "italic", textAlign: "left" }}
          >
            {expectedWidth} x {expectedHeight}
          </div>
        ) : (
          <></>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minWidth: 300,
          flexGrow: 2
        }}
      >
        <Button
          variant="outlined"
          component="label"
          fullWidth
          sx={{
            justifyContent: "flex-start",
            textTransform: "none",
            display: "flex",
            flexDirection: "column"
          }}
        >
          {logoPath ? "Change Image" : "Upload Image"}
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={async event => {
              const file = event.target.files[0];
              if (file) {
                // Create a URL for the uploaded file
                const imageUrl = URL.createObjectURL(file);
                setLogoPath(imageUrl);

                //Start file upload
                const formData = new FormData();
                formData.append("file", file);

                setUploading(true);
                try {
                  const response = await post(
                    "/theme/upload/" + ImageType,
                    formData
                  );

                  if (!(response.status == 200)) {
                    console.log("response.status", response.status);
                    throw new Error("Upload failed");
                  }

                  const result = await response.data;

                  setUploadResult(result.message);
                  setSelectedFile(null);
                  setPathFunc(result.filename);
                  // Reset file input
                  //document.getElementById("fileInput").value = "";
                } catch (error) {
                  console.log("Upload error:", error);
                  alert("Upload failed");
                } finally {
                  setUploading(false);
                }
              }
            }}
          />
        </Button>
        {logoPath && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img
              src={logoPath}
              alt="Logo preview"
              style={{
                // width: 40,
                // height: 40,
                maxWidth: 200,
                maxHeight: 80,
                objectFit: "cover",
                borderRadius: 4,
                border: "1px solid #e0e0e0"
              }}
            />
            <Button
              size="small"
              color="error"
              onClick={() => setLogoPath("")}
              sx={{ minWidth: "auto", textTransform: "none" }}
            >
              Remove
            </Button>
          </Box>
        )}
        <div>{uploading ? "Uploading, Please wait" : ""}</div>
        <div>{uploadResult}</div>
      </div>

      {/* <Button
        variant="outlined"
        component="label"
        fullWidth
        sx={{
          justifyContent: "flex-start",
          textTransform: "none",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {logoPath ? "Change Image" : "Upload Image"}
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={async event => {
            const file = event.target.files[0];
            if (file) {
              // Create a URL for the uploaded file
              const imageUrl = URL.createObjectURL(file);
              setLogoPath(imageUrl);
              console.log("DEBUG: Creating URL", imageUrl);

              //Start file upload
              const formData = new FormData();
              console.log("DEBUG: file", file);
              console.log("DEBUG: selectedFile", selectedFile);
              // formData.append("file", selectedFile);
              formData.append("file", file);
              console.log("DEBUG: formData", formData);

              setUploading(true);
              try {
                const response = await post(
                  "/theme/upload/" + ImageType,
                  formData
                );
                console.log("DEBUG: response", response);
                console.log("DEBUG: response.status", response.status);

                console.log(
                  "DEBUG: !(response.status == 200)",
                  !(response.status == 200)
                );

                if (!(response.status == 200)) {
                  console.log("response.status", response.status);
                  throw new Error("Upload failed");
                }

                const result = await response.data;
                console.log("DEBUG: json response", result);

                setUploadResult(result.message);
                setSelectedFile(null);
                setPathFunc(result.filename);
                // Reset file input
                //document.getElementById("fileInput").value = "";
              } catch (error) {
                console.log("Upload error:", error);
                alert("Upload failed");
              } finally {
                setUploading(false);
              }
            }
          }}
        />
        <div>{uploading ? "Uploading, Please wait" : ""}</div>
        <div>{uploadResult}</div>
      </Button>

      {!logoPath && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={previewImgPath}
            alt="Logo preview"
            style={{
              width: 40,
              height: 40,
              objectFit: "cover",
              borderRadius: 4,
              border: "1px solid #e0e0e0"
            }}
          />
        </Box>
      )}

      {logoPath && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img
            src={logoPath}
            alt="Logo preview"
            style={{
              width: 40,
              height: 40,
              objectFit: "cover",
              borderRadius: 4,
              border: "1px solid #e0e0e0"
            }}
          />
          <Button
            size="small"
            color="error"
            onClick={() => setLogoPath("")}
            sx={{ minWidth: "auto", textTransform: "none" }}
          >
            Remove
          </Button>
        </Box>
      )} */}
    </Box>
  );
};

export default ImageUploader;
